/*************************************************
 * VirtuOwl
 * StudentProfileAction.js
 * Copyright © 2018 concertIDC. All rights reserved.
 *************************************************/
import Client from '../../../utils/ClientVOIM';
import { ACTION_TYPES } from '../../../utils/Constants';
import { myLog } from '../../../utils/Utility';
import URL from '../../../utils/URL';

/**
 * setUpdateProfile
 * @param {Object} values
 */
export function setUpdateProfile(values) {
    return function (dispatch) {
        dispatch({
            type: ACTION_TYPES.GET_USER_INFORMATION,
            payload: values,
        });
    };
}

export const getStudentDetails = (callBack) => {
    return function () {
        Client.get(URL.IM_STUDENT.GET_STUDENT_DETAILS, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====student details error===????', error);
                callBack(false);
            });
    };
};

export function studentProfileUpload(values, callBack) {
    return function (dispatch) {
        Client.put(URL.IM_STUDENT.UPDATE_STUDENT_PROFILE, values, true)
            .then((response) => {
                myLog('====student image upload response===::::', response);
                callBack(response);
                dispatch({
                    type: ACTION_TYPES.STUDENT.UPDATE_STUDENT_PROFILE,
                    payload: response,
                });
            })
            .catch((error) => {
                myLog('====student image upload error===????', error);
                callBack(false);
            });
    };
}
